import { render, staticRenderFns } from "./distributorManagement.vue?vue&type=template&id=8cfc63ba&scoped=true"
import script from "./distributorManagement.vue?vue&type=script&lang=js"
export * from "./distributorManagement.vue?vue&type=script&lang=js"
import style0 from "./distributorManagement.vue?vue&type=style&index=0&id=8cfc63ba&prod&scoped=true&lang=scss"
import style1 from "./distributorManagement.vue?vue&type=style&index=1&id=8cfc63ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cfc63ba",
  null
  
)

export default component.exports